import React, { useEffect, useState } from "react";
import { Container, Row, Col, Pagination, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/common/Loader";
import theme from "../../styles/theme/theme";
import { fetchMyOrders } from "../../features/buyer/buyerSlice";
import "./styles.css";
import OrderCard from "../../components/buyer/OrderCard";
import RaiseDisputeModal from "../../components/buyer/RaiseDisputeModal";
import { useSearchParams } from "react-router-dom";

const MyOrders = () => {
  const dispatch = useDispatch();
  const { orders, orderLoading, orderError } = useSelector(
    (state) => state.buyer
  );
  console.log("orders:", orders);
  const [filterStatus, setFilterStatus] = useState("all");
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDisputeModal, setShowDisputeModal] = useState(false);
  const [activeOrderId, setActiveOrderId] = useState(null);
  const itemsPerPage = 6;
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const statusFromUrl = searchParams.get("status");

    if (statusFromUrl) {
      setFilterStatus(statusFromUrl.toLowerCase());
      setCurrentPage(1);
    }
  }, [searchParams]);

  useEffect(() => {
    dispatch(fetchMyOrders())
      .unwrap()
      .catch((err) => console.error("Failed to load orders:", err));
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch(fetchMyOrders());
  };

  //  Step 1: Filter orders
  const filteredOrders = orders.filter((order) =>
    filterStatus === "all"
      ? true
      : order.status.toLowerCase() === filterStatus.toLowerCase()
  );

  //  Step 2: Calculate total pages
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  //  Step 3: Paginate (slice)
  const currentOrders = filteredOrders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  //  Step 4: Render pagination items
  const paginationItems = [];
  for (let number = 1; number <= totalPages; number++) {
    paginationItems.push(
      <Pagination.Item
        key={number}
        active={number === currentPage}
        onClick={() => setCurrentPage(number)}
      >
        {number}
      </Pagination.Item>
    );
  }

  if (orderLoading) return <Loader />;
  if (orderError) return <div className="text-danger">{orderError}</div>;

  const onRaiseDispute = (orderId) => {
    setActiveOrderId(orderId);
    setShowDisputeModal(true);
  };

  return (
    <Container className="py-4 px-3 px-md-5">
      <div className="d-flex flex-nowrap justify-content-between align-items-center mb-4">
        <h3
          style={{
            color: theme.palette.text.primary,
            marginBottom: 0,
            fontSize: "1.2rem",
          }}
        >
          My Orders
        </h3>
        <Form.Select
          value={filterStatus}
          onChange={(e) => {
            setLoadingFilter(true);
            setFilterStatus(e.target.value);
            setCurrentPage(1); //  reset to page 1 on filter change
            setTimeout(() => setLoadingFilter(false), 300);
          }}
          style={{
            maxWidth: 150,
            flexShrink: 0,
          }}
        >
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="accepted">Accepted</option>
          <option value="shipped">Shipped</option>
          <option value="shipped">Picked Up</option>
          <option value="delivered">Delivered</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
          <option value="rejected">Rejected</option>
        </Form.Select>
      </div>

      {/* Orders */}
      {loadingFilter ? (
        <Loader />
      ) : (
        <Row className="gy-4">
          {currentOrders.length > 0 ? (
            currentOrders.map((order) => (
              <Col key={order.id} xs={12} md={6} lg={4}>
                <OrderCard
                  order={order}
                  onComplete={handleRefresh}
                  onRaiseDispute={() => onRaiseDispute(order.id)}
                />
              </Col>
            ))
          ) : (
            <div className="text-center text-muted">No orders found.</div>
          )}
        </Row>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <>
          <Pagination className="mt-4 justify-content-center custom-pagination">
            <Pagination.Prev
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            />
            {paginationItems}
            <Pagination.Next
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            />
          </Pagination>
          <div
            className="text-center mt-2"
            style={{ color: theme.palette.text.secondary }}
          >
            Page {currentPage} of {totalPages}
          </div>
        </>
      )}

      {showDisputeModal && (
        <RaiseDisputeModal
          show={showDisputeModal}
          orderId={activeOrderId}
          onHide={() => setShowDisputeModal(false)}
          onSuccess={() => {
            setShowDisputeModal(false);
            dispatch(fetchMyOrders());
          }}
        />
      )}
    </Container>
  );
};

export default MyOrders;
